import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from "../shared/shared.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgxChartsModule} from "@swimlane/ngx-charts";
import {HttpClientModule} from "@angular/common/http";
import {NgMaterialModule} from "../ng-material/ng-material.module";
import {
  EntityInformationComponent,
  EntityInnerNavigationComponent,
  EntityKycListComponent,
  EntityKycModalComponent,
  EntityKycNavigationComponent,
  EntityListComponent,
  EntityModalComponent,
  EntityNavigationComponent,
  KycBusinessModalComponent,
  KycBusinessSelectModalComponent,
  KycImportModalComponent,
  KycInputComponent,
  KycPersonModalComponent,
  KycPersonSelectModalComponent
} from "./components";
import {EntitiesRoutingModule} from "./entities-routing.module";
import {NgxExtendedPdfViewerModule} from "ngx-extended-pdf-viewer";
import { KycLegalEntityDisplay, KycPersonDisplay } from './components/kyc-input/kyc-input.component';
import { KycPrimaryContactPersonModalComponent } from './components/kyc-primary-contact-person-modal/kyc-primary-contact-person-modal.component';


@NgModule({
  declarations: [
    EntityInformationComponent,
    EntityNavigationComponent,
    EntityListComponent,
    EntityModalComponent,
    KycPersonModalComponent,
    KycPersonSelectModalComponent,
    KycBusinessSelectModalComponent,
    KycBusinessModalComponent,
    KycInputComponent,
    KycPersonDisplay,
    KycLegalEntityDisplay,
    EntityKycListComponent,
    EntityKycNavigationComponent,
    EntityInnerNavigationComponent,
    EntityKycModalComponent,
    KycImportModalComponent,
    KycPrimaryContactPersonModalComponent
  ],
  imports: [
    SharedModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    EntitiesRoutingModule,
    NgxChartsModule,
    HttpClientModule,
    NgMaterialModule,
    NgxExtendedPdfViewerModule
  ],
  providers: [],
  exports: []
})
export class EntitiesModule {
}
